import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const FILE_BASE = BACKEND_URL;

const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mtaa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("mtaa_token", t);
  else localStorage.removeItem("mtaa_token");
};

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${FILE_BASE}${path}`;
  return `${FILE_BASE}/api/files/${path}`;
};

// Neutral in-app placeholder for cards without a real photo (no stock imagery).
export const PLACEHOLDER_IMG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300"><rect width="100%" height="100%" fill="#1c1c1e"/><path d="M160 170l30-38 24 30 18-22 28 30" stroke="#3a3a3d" stroke-width="6" fill="none" stroke-linecap="round" stroke-linejoin="round"/><circle cx="170" cy="120" r="12" fill="#3a3a3d"/></svg>'
  );

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
